// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TZAO","colMin":"styles_colMin__1-Y8j"};